import React from "react";

// Mock data (since we don't have a real Firebase instance)
const mockData = {
    stores: ["All Stores", "CARRY BAG", "GENERAL", "VEGETABLE", "ALUMINUM FOIL", "RO CABINET SMALL", "SUP"],
    groups: ["All Groups", "CARRY BAG", "GENERAL", "VEGETABLE", "ALUMINUM FOIL", "RO CABINET SMALL", "SUP"],
    products: ["All Products", "13*16 COLOUR", "GAS 21 kg", "bt 4 lb", "Ultra Slim Display", "mango", "banana"]
};

// Filter Section Component
const FilterSection = ({ title, options, selected, onChange }) => {
    return (
        <div style={{
            backgroundColor: '#f9fafb',
            padding: '16px',
            borderRadius: '6px',
            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
        }}>
            <h2 style={{
                fontSize: '18px',
                fontWeight: 600,
                color: '#1f2937',
                marginBottom: '8px'
            }}>{title}</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {options.map((option) => (
                    <label key={option} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input
                            type="checkbox"
                            checked={selected === option}
                            onChange={() => onChange(option)}
                            style={{
                                height: '16px',
                                width: '16px',
                                color: '#2563eb',
                                borderColor: '#d1d5db',
                                borderRadius: '4px'
                            }}
                        />
                        <span style={{ fontSize: '14px', color: '#374151' }}>{option}</span>
                    </label>
                ))}
            </div>
        </div>
    );
};

// Main App Component
const StockReportGenerator = () => {
    const [reportType, setReportType] = React.useState("");
    const [filters, setFilters] = React.useState({
        store: "All Stores",
        group: "All Groups",
        product: "All Products"
    });

    const handleFilterChange = (key, value) => {
        setFilters({ ...filters, [key]: value });
    };

    const handlePrint = () => {
        window.print();
    };

    return (
        <div style={{
            width: '100%',
            maxWidth: '56rem',
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            padding: '24px',
            margin: '0 auto'
        }}>
            <h1 style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#2563eb',
                marginBottom: '16px'
            }}>Store Stock Report Generator</h1>
            
            {/* Report Type Dropdown */}
            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '16px',
                marginBottom: '24px'
            }}>
                <div>
                    <label style={{
                        display: 'block',
                        fontSize: '14px',
                        fontWeight: 500,
                        color: '#374151'
                    }}>Type</label>
                    <select
                        value={reportType}
                        onChange={(e) => setReportType(e.target.value)}
                        style={{
                            marginTop: '4px',
                            padding: '8px',
                            border: '1px solid #d1d5db',
                            borderRadius: '6px',
                            outline: 'none',
                            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
                        }}
                    >
                        <option value="">SELECT</option>
                        <option value="summary">Summary</option>
                        <option value="detailed">Detailed</option>
                    </select>
                </div>
            </div>

            {/* Filter Checkboxes */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                gap: '16px',
                marginBottom: '24px'
            }}>
                <FilterSection title="Stores" options={mockData.stores} selected={filters.store} onChange={(value) => handleFilterChange("store", value)} />
                <FilterSection title="Groups" options={mockData.groups} selected={filters.group} onChange={(value) => handleFilterChange("group", value)} />
                <FilterSection title="Product" options={mockData.products} selected={filters.product} onChange={(value) => handleFilterChange("product", value)} />
            </div>

            {/* Print Button */}
            <button
                onClick={handlePrint}
                style={{
                    backgroundColor: '#3b82f6',
                    color: 'white',
                    padding: '8px 16px',
                    borderRadius: '6px',
                    border: 'none',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s'
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#3b82f6'}
            >
                Print
            </button>
        </div>
    );
};
export default StockReportGenerator;